import Card from '@tempcover/bolt-ui/card';

interface USPCardInput {
  title: string;
  body: string;
}

export const USPCards = ({ title, cards }: { title: string; cards: USPCardInput[] }) => {
  return (
    <>
      <h2 className="lg:max-w-2/3 lg:text-[35px]">{title}</h2>
      <ul className="mt-0 flex list-none flex-col gap-4 p-0 sm:gap-6 lg:flex-row">
        {cards.map(({ title: cardTitle, body }: USPCardInput, idx: number) => (
          <li key={cardTitle + idx} className="flex-[1_1_0px]">
            <Card>
              <h3 className="text-center text-[18px] font-semibold">{cardTitle}</h3>
              <p className="text-center">{body}</p>
            </Card>
          </li>
        ))}
      </ul>
    </>
  );
};
